import angular from 'angular';
import uiRouter from 'angular-ui-router';
import tasksComponent from './tasks.component';
import dataTable from 'angular-material-data-table';

const tasksModule = angular
  .module('tasks', [uiRouter, dataTable])
  .config([
    '$stateProvider',
    $stateProvider => {
      'ngInject';
      $stateProvider.state('tasks', {
        url: '/tasks?action&operationId',
        component: 'tasks',
        parent: 'main',
        data: {
          permissions: {
            only: ['AUTHORIZED'],
            redirectTo: 'home'
          },
        },
        resolve: {
          user: ['LoginService', (LoginService) => {
            return LoginService.getCurrent();
          }],
        }
      });
    }
  ])
  .component('tasks', tasksComponent).name;

export default tasksModule;
